import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * Component for displaying the login page title
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The title text to display
 * @param {number} props.paddingBottom - Bottom padding value
 * @returns {JSX.Element} The rendered title component
 */
const LoginTitle = ({ title = "LOGIN", paddingBottom = 10 }) => {
  return (
    <Grid size="auto" pb={paddingBottom}>
      <Typography
        align="center"
        sx={{
          fontSize: { xs: "3rem", sm: "2.5rem" },
          letterSpacing: "0.1em",
        }}
      >
        {title}
      </Typography>
    </Grid>
  );
};

export default LoginTitle;
